import { FAQ, type FAQItem } from "./FAQ";
import { SectionHeader } from "./primitives";
import { SectionLayout } from "./SectionLayout";

export function FAQSection({
  items,
  num = "FAQ",
  title,
}: {
  items: FAQItem[];
  num?: string;
  title?: React.ReactNode;
}) {
  return (
    <section className="bhg-section">
      <SectionLayout>
        <SectionHeader
          num={num}
          title={title ?? (<>Common <span className="display-italic">questions.</span></>)}
        />
        <div className="mt-10">
          <FAQ items={items} />
        </div>
      </SectionLayout>
    </section>
  );
}
